import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCustomerAuth } from '../context/CustomerAuthContext';
import { LogIn, AlertCircle, UserPlus } from 'lucide-react';

const CustomerLogin = () => {
  const { login } = useCustomerAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/carrello');
    } catch {
      setError('Email o password non valide');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-10 fade-in">
      <div className="w-full max-w-md bg-white border border-neutral-200 rounded-xl p-8 shadow-sm">
        <div className="flex items-center gap-2 mb-6">
          <LogIn className="text-[#d62828]" size={22} />
          <h1 className="text-2xl font-black brand-text text-neutral-900">Accedi</h1>
        </div>
        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded text-red-800 text-sm flex items-center gap-2">
            <AlertCircle size={16} /> {error}
          </div>
        )}
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-bold text-neutral-700 mb-1">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" className="w-full px-4 py-2.5 border border-neutral-300 rounded focus:outline-none focus:ring-2 focus:ring-[#d62828]/30 focus:border-[#d62828]" />
          </div>
          <div>
            <label className="block text-sm font-bold text-neutral-700 mb-1">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" className="w-full px-4 py-2.5 border border-neutral-300 rounded focus:outline-none focus:ring-2 focus:ring-[#d62828]/30 focus:border-[#d62828]" />
          </div>
          <button type="submit" disabled={loading} className="w-full px-5 py-3 bg-[#d62828] text-white font-bold rounded hover:bg-[#b41f1f] transition-colors disabled:opacity-60">
            {loading ? 'Accesso...' : 'Accedi'}
          </button>
        </form>
        <p className="text-sm text-neutral-600 text-center mt-6">
          Non hai un account? {' '}
          <Link to="/cliente/registrati" className="text-[#d62828] font-bold inline-flex items-center gap-1">
            <UserPlus size={14} /> Registrati
          </Link>
        </p>
        <p className="text-xs text-center mt-2">
          <Link to="/cliente/password-dimenticata" className="text-neutral-500 hover:text-[#d62828]">Password dimenticata?</Link>
        </p>
      </div>
    </div>
  );
};

export default CustomerLogin;
